import { render, staticRenderFns } from "./trainBox.vue?vue&type=template&id=710be445&scoped=true"
import script from "./trainBox.vue?vue&type=script&lang=js"
export * from "./trainBox.vue?vue&type=script&lang=js"
import style0 from "./trainBox.vue?vue&type=style&index=0&id=710be445&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710be445",
  null
  
)

export default component.exports